import { onBackKeyPress } from '@utils/helpers'
import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const useGoBackNavigation = () => {
  const navigate = useNavigate()

  const handleBackPress = useCallback(
    (e: KeyboardEvent) => {
      onBackKeyPress(e, () => {
        navigate(-1)
      })
    },
    [navigate],
  )

  useEffect(() => {
    window.addEventListener('keydown', handleBackPress)
    return () => {
      window.removeEventListener('keydown', handleBackPress)
    }
  }, [handleBackPress])
}

export default useGoBackNavigation
